import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute, PublicRoute } from './components/auth';
import { LoginPage, SignUpPage, ForgotPasswordPage } from './pages/auth';
import { Dashboard } from './pages/Dashboard';
import { StockDetail } from './pages/StockDetail';
import { AIAnalysisDemo } from './pages/AIAnalysisDemo';
import { WelcomePage } from './pages/WelcomePage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route
            path="/auth/login"
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />
          <Route
            path="/auth/signup"
            element={
              <PublicRoute>
                <SignUpPage />
              </PublicRoute>
            }
          />
          <Route
            path="/auth/forgot-password"
            element={
              <PublicRoute>
                <ForgotPasswordPage />
              </PublicRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stock/:symbol"
            element={
              <ProtectedRoute>
                <StockDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ai-analysis-demo"
            element={
              <ProtectedRoute>
                <AIAnalysisDemo />
              </ProtectedRoute>
            }
          />

          <Route path="/" element={<WelcomePage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
